import { toast } from "react-toastify";
/*
The function getAdjustedEventDate adjusts the year of a given event date based on the current date. It ensures that the event date is either within the current year or in the following year if the event date 
has already passed for this year
*/
// export const getAdjustedEventDate = (eventDate, createdAtDate) => {
//   const event = new Date(eventDate);
//   const currentDate = new Date();
//   const currentYear = currentDate.getFullYear();
//   const currentMonth = currentDate.getMonth();
//   const currentDay = currentDate.getDate();

//   // Check if the event's year is already in the future
//   if (event.getFullYear() > currentYear) {
//     return event; // Keep the event date as it is
//   }

//   // Adjust the event year to the current year
//   event.setFullYear(currentYear);

//   // If the event is still in the past for the current year, set it to the next year
//   if (
//     event.getMonth() < currentMonth
//   ) {
//     event.setFullYear(currentYear + 1);
//   }

//   return event; // Return the adjusted event date
// };
export const getAdjustedEventDate = (
  eventDate,
  createdAtDate,
  eventObject,
  card
) => {
  const event = new Date(eventDate); // Convert input to a Date object
  const currentDate = new Date(); // Get the current date
  // Case 1: If the event is marked as "completed" or "printed", freeze the date
  if (
    (card?.status === "completed" || card?.status === "printed") &&
    event < currentDate
  ) {
    // If `card.frozenDate` exists, return it (preserved date when the status changed)
    if (card?.frozenDate) {
      return new Date(card.frozenDate); // Preserve the previously frozen date
    } else {
      // Freeze the current adjusted date for future reference
      card.frozenDate = event.toISOString(); // Save the adjusted date
      return event;
    }
  }

  // Case 2: Handle current month events
  if (
    event.getFullYear() === currentDate.getFullYear() &&
    event.getMonth() === currentDate.getMonth()
  ) {
    return event; // Keep current month events
  }

  // Case 3: If the event is in the past year, adjust it to the current or next year
  if (event.getFullYear() < currentDate.getFullYear()) {
    event.setFullYear(currentDate.getFullYear());
    if (event < currentDate) {
      event.setFullYear(currentDate.getFullYear() + 1);
    }
    return event;
  }

  // Case 4: If the event is this year but in the past (before current date), adjust to next year
  if (
    event.getFullYear() === currentDate.getFullYear() &&
    event < currentDate
  ) {
    event.setFullYear(currentDate.getFullYear() + 1);
    return event;
  }

  // Case 5: Handle leap years for February 29th
  if (event.getMonth() === 1 && event.getDate() === 29) {
    const nextLeapYear = findNextLeapYear(currentDate.getFullYear());
    event.setFullYear(nextLeapYear);
    return event;
  }

  // Case 6: For future events, leave them unchanged
  return event;
};

// Utility function to find the next leap year
const findNextLeapYear = (year) => {
  while (true) {
    year++;
    if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
      return year;
    }
  }
};







// export const getAdjustedEventDate = (
//   eventDate,
//   createdAtDate,
//   eventObject,
//   card
// ) => {
//   const event = new Date(eventDate); // Convert input to a Date object
//   console.log({"tttttttttttttt": event})
//   const currentDate = new Date(); // Get the current date

//   // If the event is completed and in the past, keep the event date as is
//   if (card?.status === "printed" && event < currentDate) {
//     return event; // No change in the event date
//   }

//   // // If the event is in the future or status is not completed, adjust the date
//   // if (event.getFullYear() > currentDate.getFullYear() || card?.status !== "printed") {
//   //   // if (event.getMonth() === currentDate.getMonth()) {
//   //   //   event.setFullYear(currentDate.getFullYear());
//   //   //   return event;
//   //   // }
//   //   event.setFullYear(currentDate.getFullYear() + 1);
//   //   return event;
//   // }

//   // For the cases when event date is in the past but not completed
//   if (
//     event.getFullYear() < currentDate.getFullYear() ||
//     card?.status !== "printed"
//   ) {
//     if (
//       event.getMonth() === currentDate.getMonth() &&
//       event.getFullYear() > currentDate.getFullYear()
//     ) {
//       event.setFullYear(event.getFullYear());
//       return event;
//     } else if (event.getFullYear() > currentDate.getFullYear()) {
//       event.setFullYear(event.getFullYear());
//       // console.log({ event, eventDate });
//       return event;
//     } else if (event.getMonth() === currentDate.getMonth()) {
//       event.setFullYear(currentDate.getFullYear());
//       // console.log({ event, eventDate });
//       return event;
//     } else if (
//       event.getMonth() > currentDate.getMonth() &&
//       event.getFullYear() === currentDate.getFullYear()
//     ) {
//       event.setFullYear(event.getFullYear());
//       // console.log({ event, eventDate });
//       return event;
//     }
//     event.setFullYear(currentDate.getFullYear() + 1);
//     // console.log({ event, eventDate });
//     return event;
//   }

//   return event; // Default return event if no condition matched
// };

// export const getAdjustedEventDate = (eventDate, createdAtDate) => {
//   const event = new Date(eventDate);
//   const createdAt = new Date(createdAtDate);
//   const currentDate = new Date();

//   // Set the event year to the current year initially
//   event.setFullYear(currentDate.getFullYear());

//   // If the event date is before the current date (year/month/day comparison)
//   if (event < currentDate) {
//     // If so, set the event year to next year
//     event.setFullYear(currentDate.getFullYear() + 1);
//     console.log({ adjustedEvent: event });
//   } else {
//     // If the event is today or in the future, set the year to current year
//     console.log({ notAdjustedEvent: event });
//   }

//   // Return the adjusted event
//   return event;
// };

// export const getAdjustedEventDate = (eventDate) => {
//   const event = new Date(eventDate);
//   const currentDate = new Date();

//   // Set the year of the event date to the current year initially
//   event.setFullYear(currentDate.getFullYear());

//   // Check if the event date is in the past
//   if (event < currentDate) {
//     // If the event date has passed, set it to the next year
//     event.setFullYear(currentDate.getFullYear() + 1);
//   }

//   return event;
// };

/*
 function calculates the number of days between two dates 
*/

// export const getDateDifferenceInDays = (date1, date2) => {
//   const DAY_IN_MS = 86400000;
//   const diffTime = Math.abs(date2 - date1);
//   return Math.ceil(diffTime / DAY_IN_MS);
// };
export const getDateDifferenceInDays = (date1, date2) => {
  const DAY_IN_MS = 86400000;
  const diffTime = date2 - date1;
  return Math.ceil(diffTime / DAY_IN_MS);
};

export const handleDeleteCard = async (
  ID,
  customerId,
  setCardToBeDelete,
  toggleRemoveModal,
  setLoader,
  fetchCards
) => {
  try {
    setLoader(true);
    const token = localStorage.getItem("token");
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/api/eventOfRecipient/delete-customer-order/${ID}?customerId=${customerId}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "x-sh-auth": token,
        },
      }
    );
    if (res.status === 200) {
      fetchCards();
      setCardToBeDelete({});
      toast.success("Successfully deleted");
      toggleRemoveModal();
      // window.location.href = "/dashboard/print";
    }
  } catch (error) {
    console.error("Failed to delete recipient", error);
  } finally {
    setLoader(false);
  }
};
